import { BeneficiaryFiltersDTO } from '../dtos/beneficiary'
import { RequestPayload, ResponseData, SuccessResponseDTO } from '../dtos/generic'
import { TaskDTO } from '../dtos/task'
import { defineRoute } from './new-helpers'

export const TasksRoutes = {
  createMany: defineRoute<
    'POST',
    ResponseData<TaskDTO[]>,
    RequestPayload<{
      filters: BeneficiaryFiltersDTO
      fields: Pick<TaskDTO, 'title' | 'content'> &
        Partial<Pick<TaskDTO, 'dueDate' | 'categories' | 'cta' | 'durationInHours'>>
      scope: 'all' | 'own'
    }>
  >({
    path: '/organizations/:organizationId/tasks/create',
  }),

  createOne: defineRoute<
    'POST',
    ResponseData<TaskDTO>,
    RequestPayload<{
      fields: Pick<TaskDTO, 'title' | 'content'> &
        Partial<Pick<TaskDTO, 'dueDate' | 'categories' | 'cta' | 'durationInHours'>>
    }>
  >({
    path: '/organizations/:organizationId/beneficiaries/:beneficiaryId/tasks/create-one',
  }),

  restoreOne: defineRoute<'GET', ResponseData<TaskDTO>>({
    path: '/organizations/:organizationId/beneficiaries/:beneficiaryId/tasks/:taskId/restore',
  }),

  deleteOne: defineRoute<'DELETE', ResponseData<SuccessResponseDTO>>({
    path: '/organizations/:organizationId/beneficiaries/:beneficiaryId/tasks/:taskId',
  }),

  updateOne: defineRoute<
    'PATCH',
    ResponseData<TaskDTO>,
    RequestPayload<{
      fields: Partial<
        Pick<TaskDTO, 'archivedAt' | 'categories' | 'content' | 'dueDate' | 'durationInHours' | 'title' | 'cta'>
      >
    }>
  >({
    path: '/organizations/:organizationId/beneficiaries/:beneficiaryId/tasks/:taskId',
  }),

  getAll: defineRoute<'GET', ResponseData<TaskDTO[]>>({
    path: '/organizations/:organizationId/beneficiaries/:beneficiaryId/tasks',
  }),
}
